'use client';

import {
	Anchor,
	Box,
	Button,
	Card,
	Flex,
	PasswordInput,
	SimpleGrid,
	Text,
	TextInput,
	Title,
} from '@mantine/core';
import { Breadcrumbs } from '@/ui/breadcrumbs/Breadcrumbs';
import { Metadata } from 'next';
import { AppPaths } from '@/configs/appPaths';
import APP_CONFIG from '../../configs/appConfig';
import Image from 'next/image';
import { ClientRegister } from '@/ui/clientRegister/ClientRegister';
import { useState } from 'react';
import { SlArrowRight } from 'react-icons/sl';

export default function Register() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');

	const handleRegister = async (e: React.FormEvent) => {
		e.preventDefault();

		try {
			alert('Próba rejestracji - sprawdź konsolę przeglądarki');
		} catch (error) {
			console.error('Błąd podczas rejestracji:', error);
		}
	};

	return (
		<Box maw={APP_CONFIG.CONTENT_MAX_WIDTH} m="auto">
			<Breadcrumbs
				items={[
					{
						label: 'Zarejestruj się',
						href: AppPaths.REGISTER,
					},
				]}
			/>
			<Title order={2} c="black" mb="sm">
				Zarejestruj się
			</Title>
			<SimpleGrid
				cols={{
					base: 1,
					sm: 2,
				}}
				spacing="lg"
				style={{
					alignItems: 'start',
				}}
			>
				<ClientRegister></ClientRegister>
				<Image
					src={'https://neopak.pl/dane/mainpage/kartony.jpg'}
					height={500}
					width={500}
					alt="alt"
				/>
			</SimpleGrid>
		</Box>
	);
}
